import {IOnChanges, IOnChangesObject} from "angular";

export const DirectionIndicator = "directionIndicator";

const UNCHANGED_ICON = "icon-circle-minus";
const DOWN_ICON = "icon-arrow-circle-down";
const UP_ICON = "icon-arrow-circle-up";

const UP_CLASS = "value-up";
const DOWN_CLASS = "value-down";

export function directionIndicator() {
    return {
        template,
        bindings: {
            value: "<",
            reverse: "<"
        },
        controllerAs: "ctrl",
        controller: DirectionIndicatorComponentController
    };
}

export class DirectionIndicatorComponentController implements IOnChanges {

    public value: number;
    public reverse?: boolean;
    public classes = "";

    public $onChanges(changes: IOnChangesObject): void {
        if (this.value == null || this.value === 0) {
            this.unchanged();
        } else if (this.value < 0) {
            this.down();
        } else {
            this.up();
        }
    }

    private unchanged() {
        this.classes = UNCHANGED_ICON;
    }

    private up() {
        const colour = this.reverse ? DOWN_CLASS : UP_CLASS;
        this.classes = `${colour} ${UP_ICON}`;
    }

    private down() {
        const colour = this.reverse ? UP_CLASS : DOWN_CLASS;
        this.classes = `${colour} ${DOWN_ICON}`;
    }
}

const template = `
     <i class="fa-fw" ng-class="ctrl.classes"></i>
`;
